import React, { useState } from 'react';
import { Check, Star, XIcon } from 'lucide-react';
import { WebinarMCStickyBar } from '../components/WebinarMCStickyBar';
export function WebinarMCStemGsearchPage() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  return <div className="min-h-screen bg-white font-sans text-gray-800" data-id="element-6045" data-mp="ygs56qpttydz">
      {/* Registration Popup */}
      {isPopupOpen && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4" onClick={() => setIsPopupOpen(false)} data-id="element-6046" data-mp="187whtjs1575n">
          <div className="bg-white rounded-2xl p-6 w-full max-w-sm relative" onClick={e => e.stopPropagation()} data-id="element-6047" data-mp="1d5fysrg43y1a">
            <button onClick={() => setIsPopupOpen(false)} className="absolute top-3 right-3 text-gray-400 hover:text-gray-600" data-id="element-6048" data-mp="1m87amscwgvtg">
              <XIcon className="w-6 h-6" data-id="element-6049" data-mp="3j2bth5qlmfiz" />
            </button>
            <div className="flex justify-center items-center w-full pt-4" data-id="element-6050" data-mp="3nztu88ugpofw">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-gsearch_cmp-mcc_pt-video" height="500" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
            border: 'none',
            borderRadius: '15px',
            backgroundColor: 'white',
            maxWidth: '100%'
          }} data-id="element-6051" data-mp="3ar64dr39aa7j"></iframe>
            </div>
            <p className="text-xs text-gray-500 text-center mt-3" data-id="element-6052" data-mp="3ppi1fyujjkz8">
              We HATEN spam. Je e-mailadres is 100% veilig
            </p>
            <div className="flex items-center gap-3 mt-3 px-2" data-id="element-6053" data-mp="3kqx201n455bu">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kJ5b6tBbH8hDNt52JG84mT/Scherm%C2%ADafbeelding_2025-08-15_om_15.44.02.png" alt="Amee Buijs" className="w-9 h-9 rounded-full object-cover flex-shrink-0" data-id="element-6054" data-mp="3fphem2xgqmqa" />
              <p className="text-xs text-gray-600 leading-snug" data-id="element-6055" data-mp="25t2fnmwpz9fa">
                Dit webinar wordt gegeven door Amee Buijs, honden
                gedragsdeskundige met 10 jaar ervaring.
              </p>
            </div>
          </div>
        </div>}

      {/* Navigation */}
      <nav className="w-full border-b border-gray-200 py-4 px-6 bg-white" data-id="element-6056" data-mp="21pmov77c03ai">
        <div className="flex justify-center md:justify-between items-center" data-id="element-6057" data-mp="1n1i0bmllkxjt">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-10 object-contain" data-id="element-6058" data-mp="1mzf6erhbqk9t" />
          <div className="hidden md:block" data-id="element-6059" data-mp="1i1x4vm5mz7bu">
            <div className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="500px" data-theme="light" data-id="element-6060" data-mp="1i2oodylylelr">
              <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener noreferrer" data-id="element-6061" data-mp="kh3vuorl4t34">
                Trustpilot
              </a>
            </div>
          </div>
        </div>
        <div className="md:hidden flex justify-center mt-3 w-full" data-id="element-6062" data-mp="uh4m6unvg9gt">
          <div className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="100%" data-token="d24193a8-3943-4d9c-bcbd-f0b97f9d6fb9" data-id="element-6063" data-mp="18di0xw10twrl">
            <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener" data-id="element-6064" data-mp="1r5alr35xsbo8">
              Trustpilot
            </a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="max-w-6xl mx-auto px-4 py-12 md:py-20 grid md:grid-cols-12 gap-12 items-center" data-id="element-6065" data-mp="3gm65wxeicpff">
        <div className="md:col-span-7" data-id="element-6066" data-mp="3ljfzmp8xjn92">
          <p className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-4" data-id="element-6067" data-mp="3qbppy6dyipbv">
            Gratis Online Webinar: Communiceren met je Hond
          </p>
          <h1 className="text-4xl md:text-5xl font-extrabold text-[#1a2b4a] mb-6 leading-tight" data-id="element-6068" data-mp="3vd591swkqlrm">
            Wat probeert je hond je te zeggen?
          </h1>
          <button onClick={() => setIsPopupOpen(true)} className="md:hidden mx-auto block bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md mb-4" data-id="element-6069" data-mp="32ng4x6oki5ls">
            Inschrijven webinar
          </button>
          <div className="md:hidden flex items-center justify-center gap-4 mb-8" data-id="element-6070" data-mp="muhaft6pc1kb">
            <div className="flex -space-x-3" data-id="element-6071" data-mp="qwckbm2p7n9p">
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-6072" data-mp="qz737962d010" />
              <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-6073" data-mp="22m1li0sdzanm" />
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-6074" data-mp="1smkffi982ur4" />
            </div>
            <div data-id="element-6075" data-mp="1eq7at9psenu2">
              <p className="font-bold text-lg text-[#1a2b4a]" data-id="element-6076" data-mp="1eqqhfu9zlpss">97.283+</p>
              <p className="text-xs text-gray-600" data-id="element-6077" data-mp="3e0yoyfpbi2ei">
                Baasjes volgden al dit webinar
              </p>
            </div>
          </div>
          <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-6078" data-mp="3912k6e8sq6xw">
            Ontdek in dit gratis 90-minuten webinar de eenvoudige, liefdevolle
            methode die duizenden hondenbaasjes nu gebruiken om hun hond te
            begrijpen.
          </p>

          <ul className="space-y-4 mb-8" data-id="element-6079" data-mp="3j857l79623jx">
            {['Waarom je hond doet wat hij doet - en waarom je het tot nu toe verkeerd hebt begrepen', 'De taal van je hond - leer de signalen lezen van je hond zodat je ziet wat hij denkt, voelt en wilt', 'Wat angst, stress en onzekerheid werkelijk betekenen - en hoe je ze herkent', 'Waarom "ongehoorzaamheid" een mythe is - en hoe je zorgt dat jou hond weet wat je van hem wilt', 'Hoe je de wereld vanuit je hond ziet - zodat je "onverklaarbaar gedrag" ineens begrijpt', 'De 3 kernbehoeften van elke hond - en hoe deze je helpen om een rustigere blijere hond te krijgen'].map((item, i) => <li key={i} className="flex items-start" data-id="element-6080" data-mp="2vewrzgc9u3rp" data-mpi={i}>
                <Check className="w-6 h-6 text-blue-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-6081" data-mp="2nwfb2p22fmop" />
                <span className="text-gray-700 font-medium" data-id="element-6082" data-mp="2ixlxkwms3voj">{item}</span>
              </li>)}
          </ul>

          <div className="hidden md:flex items-center gap-4" data-id="element-6083" data-mp="2wxwq043qlibt">
            <div className="flex -space-x-3" data-id="element-6084" data-mp="2rytxfj4y14kq">
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-6085" data-mp="2s04wx6rcvq61" />
              <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-6086" data-mp="2e03z606e0yus" />
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-6087" data-mp="1lhgjx1e2oe1m" />
            </div>
            <div data-id="element-6088" data-mp="100zrb51q3x9f">
              <p className="font-bold text-xl text-[#1a2b4a]" data-id="element-6089" data-mp="100gkokhiwvap">97.283+</p>
              <p className="text-sm text-gray-600" data-id="element-6090" data-mp="14yrsyqs66xqt">
                Baasjes volgden al dit webinar
              </p>
            </div>
          </div>
        </div>

        <div className="md:col-span-5 flex justify-center" data-id="element-6091" data-mp="1ex7co8ovb4qa">
          <div className="p-6 rounded-3xl w-full max-w-sm mx-auto" data-id="element-6092" data-mp="1ewphlfdxywjy">
            <div className="flex justify-center items-center w-full" data-id="element-6093" data-mp="1iy0y8veu87g0">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-gsearch_cmp-mcc_pt-video" height="550" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
              border: 'none',
              borderRadius: '25px',
              backgroundColor: 'white',
              maxWidth: '100%'
            }} data-id="element-6094" data-mp="1npiyticy860g"></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* 3 Steps Section */}
      <section className="bg-gray-50 py-20" data-id="element-6095" data-mp="3i83v6vkhb3hb">
        <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-6096" data-mp="3d7pmdbb1zpi8">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-16" data-id="element-6097" data-mp="387l8zu5fzaw8">
            Leer de taal van je hond in drie stappen
          </h2>

          <div className="grid md:grid-cols-3 gap-12 mb-12" data-id="element-6098" data-mp="9omp1sntppqt">
            <div className="flex flex-col items-center" data-id="element-6099" data-mp="4qbcha65914w">
              <img src="https://cdn.magicpatterns.com/uploads/7G3FddFkmDX1PP48Js3VUV/agenda_icon_(1).png" alt="Agenda icoon" className="w-32 h-32 object-contain mb-6" data-id="element-6100" data-mp="4rmotydnnh7m" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-6101" data-mp="sg5ojpin2lo3">Stap 1.</h3>
              <p className="text-gray-600" data-id="element-6102" data-mp="sia2z1e5z32m">
                Vul het formulier in en reserveer jouw plekje
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-6103" data-mp="31vxayc5lbgv0">
              <img src="https://cdn.magicpatterns.com/uploads/oxDbACMiW4Zh5cMbL7Ry7C/cursor_webinar_v3_(1).png" alt="Webinar knop icoon" className="w-32 h-32 object-contain mb-6" data-id="element-6104" data-mp="31yied5lje4uv" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-6105" data-mp="36viihaytsxjc">Stap 2.</h3>
              <p className="text-gray-600" data-id="element-6106" data-mp="3kvb4wu3bkrli">
                Klik tegen die tijd op de link in je e-mail om direct deel te
                nemen
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-6107" data-mp="3gs51rvbi7gj9">
              <img src="https://cdn.magicpatterns.com/uploads/swcfYXFhsSevmDxKpdEyU7/vrouw_hond_knuffel_(1).png" alt="Vrouw knuffelt hond" className="w-32 h-32 object-contain mb-6" data-id="element-6108" data-mp="3uk1jr6jgka1x" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-6109" data-mp="3f1r5niu9581">Stap 3.</h3>
              <p className="text-gray-600" data-id="element-6110" data-mp="3cyrebrvvxq4">
                Leer in 90 minuten hoe je de taal van je hond leert spreken
              </p>
            </div>
          </div>

          <button onClick={() => setIsPopupOpen(true)} className="bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md" data-id="element-6111" data-mp="r15f6j9p5iwa">
            Inschrijven webinar
          </button>
        </div>
      </section>

      {/* Social Proof / Testimonials */}
      <section className="py-20 bg-[#fbfaf8]" data-id="element-6112" data-mp="3b17o0te0z00">
        <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-6113" data-mp="84m9k3y3qd4h">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-16 max-w-3xl mx-auto leading-tight" data-id="element-6114" data-mp="3qhk7647f8tvh">
            Duizenden baasjes gingen je voor - en zeggen allemaal hetzelfde:{' '}
            <br data-id="element-6115" data-mp="3gje2xfy57bng" />
            <span className="italic" data-id="element-6116" data-mp="3givyvx58nt4z">"Ik begrijp mijn hond nu pas echt."</span>
          </h2>

          {/* Videos */}
          <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-6117" data-mp="3lhfllzrnp8ye">
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-6118" data-mp="32dvma1b3lafk">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-6119" data-mp="32fyn7gdsgnz2">
                <iframe src="https://player.vimeo.com/video/1086787571?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 2" data-id="element-6120" data-mp="2sp3zs8ot3ic1"></iframe>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-6121" data-mp="2006jgb45nvlx">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-6122" data-mp="1v00y1cohb5ca">
                <iframe src="https://player.vimeo.com/video/1086787549?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 3" data-id="element-6123" data-mp="agf0yrftqr5r"></iframe>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-6124" data-mp="18606d5558kng">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-6125" data-mp="183xjgtzaf7my">
                <iframe src="https://player.vimeo.com/video/1086787601?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 1" data-id="element-6126" data-mp="39yfztvgyoiw9"></iframe>
              </div>
            </div>
          </div>

          {/* Review Grid */}
          <div className="grid md:grid-cols-2 gap-6 mb-16 text-left" data-id="element-6127" data-mp="ghp4somsq6ou">
            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-6128" data-mp="uc7xu9gunxuh">
              <div className="flex items-center mb-4" data-id="element-6129" data-mp="pin8f5tboc6w">
                <div className="flex text-green-500 mr-2" data-id="element-6130" data-mp="1udsulmpcko7">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-6131" data-mp="3tyy22jc9v2ih" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-6132" data-mp="3jtge9ud2pf16">8 jul 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-6133" data-mp="3olg7z52jvbpb">
                Hele fijne cursus. Aanrader zelfs voor de ervaren honden
                liefhebber.
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-6134" data-mp="3ev52vf74qwgu">
                Nu hebben wij altijd herplaatsers, dus we zijn wel wat gewend.
                Maar bij onze laatste herplaatser hebben we wel hulp nodig. In
                kort tijd nu al zoveel geleerd en handvaten gekregen. Ben enorm
                enthousiast over deze cursus en ik kreeg ook veel hulp
                aangeboden. Het is netjes overzichtelijk, duidelijk maar wat met
                het meeste aanspreekt is dat het zonder commando's gaat maar via
                communiceren.
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-6135" data-mp="2m6pql0fdus97">
                - Nicolette
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-6136" data-mp="soa3x8rtenym">
              <div className="flex items-center mb-4" data-id="element-6137" data-mp="nodyr67dsqhh">
                <div className="flex text-green-500 mr-2" data-id="element-6138" data-mp="nr0dpqwlq89q">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-6139" data-mp="ivujm4t1pnak" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-6140" data-mp="901a6uami9x0">3 sep 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-6141" data-mp="4yfp4lnxqpbq">
                Niet goed maar uitstekend!
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-6142" data-mp="3w47brb2i7jts">
                Amée is een zeer lieve vrouw met een hart voor honden en dat
                merk je zeer goed. De tips helpen echt. Ik raad iedereen met
                puppy's, jongere hondjes en alle andere leeftijden deze cursus
                aan, vooral mensen die problemen hebben met hun troetel. Zowel
                gedragsproblemen als medische problemen. Volg even de gratis
                Masterclass en je bent volledig overtuigd van de cursus en de
                mensen erachter. Heel veel liefs aan iedereen van het team.
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-6143" data-mp="26owohd3pz13m">
                - Tine Oetzmann
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-6144" data-mp="2boj2hordgldh">
              <div className="flex items-center mb-4" data-id="element-6145" data-mp="1e10uwh9g5pb2">
                <div className="flex text-green-500 mr-2" data-id="element-6146" data-mp="1ix7tfozijyiz">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-6147" data-mp="1nwaw52s0tsns" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-6148" data-mp="1sxrx0yai9f4d">20 apr 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-6149" data-mp="2zbhfgcga9b6n">
                Dit was de eerste keer dat ik een online hondencursus volgde...
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-6150" data-mp="3pf4t5swu4360">
                Dit was de eerste keer dat ik een online hondencursus volgde en
                ik heb er veel van opgestoken. Hoewel mijn honden zich (meestal)
                prima gedragen, wilde ik vooral leren wat ik zelf nog een beter
                kan doen ivm de communicatie. Dat is gelukt, het valt echt op
                dat omdat ik mij zelf anders opstel, mijn honden nu veel
                rustiger communiceren met andere honden. Vooral met onbekende
                honden was er toch vaak wel flink geblaf. Nu bijna niet meer,
                heerlijk, wat is wandelen toch/weer een genot. Idd: stressless!
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-6151" data-mp="gzbe7ii5izr2">
                - Margreet
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-6152" data-mp="2nqkkdz1fmkyz">
              <div className="flex items-center mb-4" data-id="element-6153" data-mp="2is9axpf1ucha">
                <div className="flex text-green-500 mr-2" data-id="element-6154" data-mp="y96yisnfj0sh">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-6155" data-mp="138jhv3f3dpqb" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-6156" data-mp="ojvpt74gfy54">13 aug 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-6157" data-mp="thoz4912189m">
                Ik vond het prettig mijn ervaring op te halen...
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-6158" data-mp="fh4ed7bkx2dh">
                Ik vond het prettig mijn ervaring op te halen en voorbereid te
                zijn op de puppy die ik al snel krijg. Goed gewerkt!
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-6159" data-mp="ajcik27tcw40">
                - Henne Buskermolen
              </p>
            </div>
          </div>

          <button onClick={() => setIsPopupOpen(true)} className="bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md" data-id="element-6160" data-mp="1zyslgzv59llg">
            Inschrijven webinar
          </button>
        </div>
      </section>

      {/* About Amee */}
      <section className="py-20 bg-white" data-id="element-6161" data-mp="3da35e8zc22ew">
        <div className="max-w-5xl mx-auto px-4 grid md:grid-cols-2 gap-12 items-center" data-id="element-6162" data-mp="2zhmyuy783m98">
          <div data-id="element-6163" data-mp="34ff1on9eoss7">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-6 leading-tight" data-id="element-6164" data-mp="34gzua7c5u1nf">
              Hoi, ik ben Amee en ik geef dit webinar.
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-6165" data-mp="1gk569j9ilr">
              <p data-id="element-6166" data-mp="3w509lkqabjms">
                Ik ben Amee de Bruijn, hondengedragsdeskundige en oprichter van
                StresslessDogs.nl. Maar veel belangrijker: ik ben iemand die
                precies begrijpt wat je voelt als je hond je frustreert en je
                niet weet hoe je hem beter kunt begrijpen.
              </p>
              <p data-id="element-6167" data-mp="2bqzpe8hnsokk">
                In de afgelopen jaren heb ik meer dan 15.000 hondenbaasjes en
                hun honden mogen begeleiden. Niet om hen te 'trainen' in de
                traditionele zin, maar om hen te helpen wat ik zelf ook ontdekt
                heb: dat echte verandering begint met communicatie, niet met
                commando's.
              </p>
              <p data-id="element-6168" data-mp="2d62dn18fsnxg">
                Wat ik in al die jaren heb gezien, is dat de meeste frustratie
                niet voortkomt uit een 'slecht' hond of een 'falende' baas. Het
                komt voort uit onbegrip. Uit het feit dat baasjes en honden
                letterlijk twee verschillende talen spreken. Zodra je die taal
                van je hond leert, verdwijnt de frustratie. De strijd maakt
                plaats voor samenwerking. En de band wordt onverwoestbaar.
              </p>
              <p data-id="element-6169" data-mp="1ph10x1skmqmd">
                Daarom werk ik uitsluitend met methodes die gebaseerd zijn op
                vertrouwen, veiligheid, wederzijds respect en echte
                communicatie. Geen dwang, geen pijn, geen angst, geen straf.
                Alleen liefde en begrip. Want dat is wat zowel jij als je hond
                verdienen.
              </p>
              <p data-id="element-6170" data-mp="31u7svggymyaa">
                Dit webinar is mijn manier om dit geheim met zoveel mogelijk
                hondenbaasjes te delen. Omdat ik geloof dat elke hond en elke
                mens de kans verdient om elkaar écht te begrijpen.
              </p>
            </div>
          </div>
          <div className="rounded-2xl overflow-hidden shadow-xl" data-id="element-6171" data-mp="2dylkxogrs0e7">
            <img src="https://cdn.magicpatterns.com/uploads/vXmyJc5cCVvbLnBaXGCixn/682f298cbb713_AmeemetSophietje1.png" alt="Amee met Sophietje" className="w-full h-auto object-cover" data-id="element-6172" data-mp="2iweqcfa90qdf" />
          </div>
        </div>
      </section>

      {/* Bottom Registration */}
      <section className="py-20 bg-gray-50" data-id="element-6173" data-mp="36ad6kg3nr15">
        <div className="max-w-md mx-auto px-4" data-id="element-6174" data-mp="37liiop716ud">
          <div className="p-6 rounded-3xl w-full" data-id="element-6175" data-mp="76cir4oyh4lp">
            <div className="flex justify-center items-center" data-id="element-6176" data-mp="79718qoesfch">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-gsearch_cmp-mcc_pt-video" height="550" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
              border: 'none',
              borderRadius: '25px',
              backgroundColor: 'white'
            }} data-id="element-6177" data-mp="1rnv3lepgyitf"></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-12" data-id="element-6178" data-mp="141wx5o6pwlz3">
        <div className="max-w-6xl mx-auto px-4 flex flex-col items-center text-center" data-id="element-6179" data-mp="zyigqweva3l4">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-12 object-contain mb-6" data-id="element-6180" data-mp="v076wloknt2w" />
          <p className="font-semibold text-[#1a2b4a] mb-2" data-id="element-6181" data-mp="2pb2ebko0t243">
            Voor liefdevolle hondenbaasjes
          </p>
          <a href="mailto:amee@stresslessdogs.nl" className="text-blue-600 hover:underline mb-8" data-id="element-6182" data-mp="1r0u762vcyix2">
            amee@stresslessdogs.nl
          </a>

          <div className="text-xs text-gray-500 max-w-3xl leading-relaxed" data-id="element-6183" data-mp="1i0e6t29wvrwf">
            <p className="mb-2" data-id="element-6184" data-mp="1hyl1bqb1bdq0">
              © 2025 Stressless Dogs. Alle rechten voorbehouden.
            </p>
            <p data-id="element-6185" data-mp="139ot9t8za0pe">
              Deze website maakt gebruik van cookies en vergelijkbare
              technologieën voor analytische en advertentiedoeleinden. Deze
              pagina is een advertorial voor Stressless Dogs. Stressless Dogs is
              een onafhankelijk bedrijf en is op geen enkele wijze verbonden aan
              of onderdeel van Meta (voorheen Facebook). Deze advertentie wordt
              getoond via het Meta advertentieplatform, maar Meta is niet
              verantwoordelijk voor de inhoud of diensten aangeboden door
              Stressless Dogs.
            </p>
          </div>
        </div>
      </footer>
      <WebinarMCStickyBar onClickCTA={() => setIsPopupOpen(true)} data-id="element-6186" data-mp="rnfpy2pbgxw" />
    </div>;
}